export default "__VITE_ASSET__DJfHZ0u5__"